import { render, staticRenderFns } from "./trigger-action-config.vue?vue&type=template&id=6d39af61"
import script from "./trigger-action-config.ts?vue&type=script&lang=js&external"
export * from "./trigger-action-config.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports